"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.read = exports.write = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveStringSaver_sidecar_1 = require("./diveStringSaver-sidecar");
var version = 'v0.1.8';
var namespace = 'crews';
var item = 'crew';
function write() {
    var e_1, _a;
    diveStringSaver_sidecar_1.diveStringSaver.wHeader(namespace, version);
    var objs = diveCrew_sidecar_1.diveCrew.getAll();
    try {
        for (var objs_1 = __values(objs), objs_1_1 = objs_1.next(); !objs_1_1.done; objs_1_1 = objs_1.next()) {
            var c = objs_1_1.value;
            if (c.isDead || c.isDying) {
                continue;
            }
            // if (c.type !== EVoyageCrewType.Crew) {
            //   continue
            // }
            diveStringSaver_sidecar_1.diveStringSaver.wString(item);
            // console.log('writing crew', c.id, c.lerp_target_x, c.lerp_target_y)
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.id);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.type);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.heroType);
            diveStringSaver_sidecar_1.diveStringSaver.wString(c.enemyType);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.rando.getCurrentSeed());
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.i);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.j);
            diveStringSaver_sidecar_1.diveStringSaver.wBool(c.isFlipped);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.hitpoints);
            diveStringSaver_sidecar_1.diveStringSaver.wBool(c.isDownStairs);
            diveStringSaver_sidecar_1.diveStringSaver.wBool(c.isUpStairs);
            diveStringSaver_sidecar_1.diveStringSaver.wBool(c.isAwake);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.ticksAwake);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.stunLeft);
            diveStringSaver_sidecar_1.diveStringSaver.wString(c.name);
            // TODO: save movement / attack state
            // TODO: save hero state
            // TODO: save ai state, etc.
            diveStringSaver_sidecar_1.diveStringSaver.wBool(!!c.enemyState);
            if (c.enemyState) {
                // diveStringSaver.wInt(c.enemyState.aiType)
                diveStringSaver_sidecar_1.diveStringSaver.wInt(c.enemyState.abilityTimerTicks);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (objs_1_1 && !objs_1_1.done && (_a = objs_1.return)) _a.call(objs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    diveStringSaver_sidecar_1.diveStringSaver.wEnd(namespace);
}
exports.write = write;
function read() {
    diveStringSaver_sidecar_1.diveStringSaver.rHeader(namespace, version);
    diveCrew_sidecar_1.diveCrew.killAll('loading new crew');
    while (diveStringSaver_sidecar_1.diveStringSaver.rPeek(item)) {
        diveStringSaver_sidecar_1.diveStringSaver.rString(item);
        var id = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var type = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var heroType = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var enemyType = diveStringSaver_sidecar_1.diveStringSaver.rString();
        var seed = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var i = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var j = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var isFlipped = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        var hitpoints = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var isDownStairs = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        var isUpStairs = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        var isAwake = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        var ticksAwake = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var stunLeft = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var name_1 = diveStringSaver_sidecar_1.diveStringSaver.rString();
        var c = diveCrew_sidecar_1.diveCrew.create(type, heroType, enemyType, 0, id);
        c.rando.setCurrentSeed(seed);
        diveCrew_sidecar_1.diveCrew.moveToIIJ(c, { i: i, j: j });
        c.isFlipped = isFlipped;
        c.hitpoints = hitpoints;
        c.isDownStairs = isDownStairs;
        c.isUpStairs = isUpStairs;
        c.isAwake = isAwake;
        c.ticksAwake = ticksAwake;
        c.stunLeft = stunLeft;
        c.name = name_1;
        // TODO: restore movement / attack state
        // TODO: restore hero state
        var hasEnemyState = diveStringSaver_sidecar_1.diveStringSaver.rBool();
        if (hasEnemyState) {
            // let aiType = diveStringSaver.rInt() as EAlienAi
            var abilityTimerTicks = diveStringSaver_sidecar_1.diveStringSaver.rInt();
            assert_sidecar_1.assert.notNil(c.enemyState);
            c.enemyState.abilityTimerTicks = abilityTimerTicks;
        }
    }
    diveStringSaver_sidecar_1.diveStringSaver.rEnd(namespace);
}
exports.read = read;
